import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { BillingRun } from 'src/features/billingRuns/utils/types';

const RESOURCE = '/charges/billing-run/:billingRunId/';

type QueryFnType = typeof queryFn;

interface DTO {
    billingRunId: string;
}
const queryFn = ({ billingRunId }: DTO): Promise<BillingRun> => {
    return axios.get(formatResourcePath(RESOURCE, { billingRunId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetBillingRun, RESOURCE as BILLING_RUN_RESOURCE };
